export default __webpack_public_path__ + "static/media/home.027a1fc7.svg";